import { useTranslation } from "next-i18next";
import { default as WorkingatHub } from "../../../../../public/media/company-facts/working-at-nwon-1.jpg";
import { CompanyFact } from "../../../../interfaces/team";

export const useCompanyFactWorkHere = (): CompanyFact => {
  const { t } = useTranslation<"companyFacts">("companyFacts");

  return {
    title: t("workHere.title"),
    description: t("workHere.description"),
    image: WorkingatHub,
  };
};
